<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
          v-if="$acl.get[0] === 'editor'"
        >
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <ul class="users-liked user-list p-4 inline-flex rounded">
            <img
              :src="logo"
              width="80"
              class="rounded-full border-2 d-theme-border-grey-light border-solid"
            />
          </ul>
          <h2 class="mb-3 text-white">
            Congratulations {{ FullName.split(" ")[0] }}
          </h2>
          <h6 class="text-white">Share your Referral ID</h6>
          <span>
            <div class="inline-flex" id="CopyCode">
              <vs-input disabled="true" v-model="RefCode" />
            </div>
            <vs-button
              class="ml-5 mt-6"
              color="#FFFFFF"
              type="border"
              v-clipboard:copy="path"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              Copy</vs-button
            >
          </span>
          <!-- <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have been subscribed to a <strong>Premium Account</strong>. Now get connected to hundreds of colleges across India.</p> -->
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card v-if="$acl.get[0] !== 'admin'" title="Milestone Board">
          <!--:title="title1" -->
          <!--<div class="px-5 flex flex-wrap">
            <vx-tooltip text="Download Certificate">
              <vs-button
                class="mr-5 mb-2"
                v-if="mile3"
                icon-pack="feather"
                icon="icon-download"
                @click="generatePDF()"
                >Download Certificate</vs-button
              >
            </vx-tooltip>
            <vx-tooltip text="Download Certificate">
              <vs-button
                class="mr-5 mb-2"
                v-if="mile4"
                icon-pack="feather"
                icon="icon-download"
                @click="generatePDF()"
                >Download Certificate</vs-button
              >
            </vx-tooltip>
          </div>-->
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-10">
              <p>Milestone 1 (20 Referrals)</p>

              <vs-progress
                class="block mt-1"
                :percent="milestone1"
                color="primary"
              ></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-10">
              <p>Milestone 2 (50 Referrals)</p>

              <vs-progress
                class="block mt-1"
                :percent="milestone2"
                color="warning"
              ></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-10">
              <p>Milestone 3 (150 Referrals)</p>

              <vs-progress
                class="block mt-1"
                :percent="milestone3"
                color="danger"
              ></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-10">
              <p>Milestone 4 (300 Referrals)</p>
              <vs-progress
                class="block mt-1"
                :percent="milestone4"
                color="success"
              ></vs-progress>
            </div>
          </div>
          <!--<vs-divider></vs-divider>
          <div class="vx-row">
            <div class="vx-col md:w-1/2">
              <vx-tooltip text="Download Internship Certificate">
                <vs-button
                  class="mr-5 mb-2"
                  :disabled="!mile1"
                  icon-pack="feather"
                  icon="icon-download"
                  @click="generatePDF()"
                  >Download Certificate</vs-button
                >
              </vx-tooltip>
            </div>
            <div class="vx-col md:w-1/2">
              <vx-tooltip text="Download Letter of Reccomendation">
                <vs-button
                  class="mr-5 mb-2"
                  :disabled="!mile2"
                  icon-pack="feather"
                  icon="icon-download"
                  @click="generateLOR()"
                  >Download LOR</vs-button
                >
              </vx-tooltip>
            </div>
          </div>-->
        </vx-card>
      </div>
      <!-- <iframe src="" id ='pdf' height="500px" width="300px" ></iframe> -->
    </div>
    <!-- <div class="vx-row">
      <div
        class="vx-col w-full text-center justify-between ml-auto mr-auto mb-base"
        v-if="RefCode !== ''"
      >
        <vx-card class="p-2">
          <div class="text-center">
            <h4>Share this Referral Code</h4>
            <p class="text-primary font-semibold">
              use this code when registering new accounts
            </p>
          </div>
          <span>
            <div class="inline-flex">
              <vs-input v-model="RefCode" />
            </div>
            <vs-button
              class="ml-5 mt-6"
              color="primary"
              v-clipboard:copy="path"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              Copy</vs-button
            >
          </span>
        </vx-card>
      </div>
    </div>-->
    <div class="vx-row">
      <vx-card class="mt-5">
        <vs-table
          ref="table"
          pagination
          title="Your Referrals"
          :max-items="itemsPerPage"
          :data="users"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between mb-3"
          >
            <h4>Your Referrals</h4>
            <!-- ITEMS PER PAGE -->
            <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-3 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    users.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : users.length
                  }}
                  of {{ users.length }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 20">
                  <span>20</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown> -->
          </div>

          <template slot="thead">
            <vs-th>Candidate Name</vs-th>
            <vs-th sort-key="CollegeName">College Name</vs-th>
            <vs-th sort-key="courseName">Course</vs-th>

            <!--<vs-th sort-key="Status">Status</vs-th>
        <vs-th sort-key="vacancies">Openings</vs-th>-->
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <td>
                  <span class="flex">
                    <vs-avatar :src="tr.profilephoto" />
                    <p
                      v-if="tr.FullName"
                      class="product-name font-semibold font-medium mt-3 ml-2 hover:text-primary"
                    >
                      {{ tr.FullName }}
                    </p>
                    <p
                      v-else
                      class="product-name font-semibold font-medium mt-3 ml-2 hover:text-primary"
                    >
                      {{ tr.username }}
                    </p>
                  </span>
                </td>
                <td>
                  <p class="product-name mt-2 font-medium">
                    {{ tr.CollegeName }}
                  </p>
                </td>
                <td>
                  <p class="product-name mt-2 font-medium">
                    {{ tr.courseName }}
                  </p>
                </td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <!--<vx-card  title="Days Per Hire" v-if="$acl.get[0] === 'post'">
                    DATA 
                    <div class=" justify-between text-center p-4 " slot="no-body-bottom">
                      <div class="w-full ">
                        <p class="mb-1 p-2  flex  text-lg">Jobs<vs-spacer/><span class="text-dark">{{jobclose}} Days</span></p>
                        <p class="mb-1 p-2  flex text-lg">Internships<vs-spacer/><span class="text-dark">{{internshipclose}} Days</span></p>
                      </div>
                        <div class="flex w-full mt-2  justify-center">
                             <vs-button  class=" items-center lg:mt-0">Post New</vs-button>
                        </div>
                    </div>
                  
                </vx-card>-->
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      checkpointReward: {},
      goalOverview: {},
      subscribersGained: {},

      salesBarSession: {},
      supportTracker: {},
      totalstudent: 0,
      totaljobs: 0,
      totalinternships: 0,
      totalRecruiters: 0,
      placedstudents: 0,
      FullName: "",
      users: [],
      apply: [],
      dis: true,
      use: [],
      jobs: [],
      internclose: [],
      title1: "Progress",
      dispatchedOrders: [],
      total_jobs: 0,
      total_internships: 0,
      colid: "",

      StudentCode: "",
      limitsize: 0,
      logo: "",
      itemsPerPage: 5,
      isMounted: false,
      RCode: "",
      RefCode: "",
      milestone1: 0,
      milestone2: 0,
      milestone4: 0,
      milestone3: 0,
    };
  },
  components: {},
  watch: {
    apply() {
      this.res;
    },
  },
  methods: {
    async codegen() {
      let thisIns = this;
      let ocode = [];
      await firebase
        .firestore()
        .collection("Codes")
        .doc("ReferralCodes")
        .get()
        .then((doc) => {
          if (doc.exists) {
            ocode = doc.data().RefCodes;

            // console.log(rcode)
            // console.log(this.RecruiterCode)
          }
        })
        .then(async () => {
          // console.log(id)
          var result = "";
          var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
          var charactersLength = characters.length;
          for (var i = 0; i < 7; i++) {
            result += characters.charAt(
              Math.floor(Math.random() * charactersLength)
            );
          }
          if (ocode.includes(result)) {
            this.codegen();
          } else {
            thisIns.RCode = result;
            await firebase
              .firestore()
              .collection("Codes")
              .doc("ReferralCodes")
              .set(
                {
                  RefCodes: firebase.firestore.FieldValue.arrayUnion(result),
                },
                { merge: true }
              );
          }
          console.log(thisIns.RCode);
        });
    },
    async generatePDF() {
      let name = this.FullName;

      var options = { year: "numeric", month: "long", day: "numeric" };
      var today = new Date();

      let currentdate = today.toLocaleDateString("en-US", options);
      const url = this.certificate;
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer()
      );

      // Load a PDFDocument from the existing PDF bytes
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      // //get font
      let fonturl =
        "https://firebasestorage.googleapis.com/v0/b/flairboat-9a97e.appspot.com/o/Roboto-Black.ttf?alt=media&token=1e624ecc-5b48-4502-b293-f8a84243bca2";
      const fontBytes = await fetch(fonturl).then((res) => res.arrayBuffer());

      // // Embed our custom font in the document
      const SanChezFont = await pdfDoc.embedFont(fontBytes);
      // const SanChezFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

      // // Get the first page of the document
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      // // Draw a string of text diagonally across the first page
      firstPage.drawText(currentdate, {
        x: 120,
        y: 120,
        size: 20,
        font: SanChezFont,
        color: rgb(0.266, 0.266, 0.266),
      });
      if (name.length <= 5) {
        firstPage.drawText(name, {
          x: 370,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length > 5 && name.length <= 10) {
        firstPage.drawText(name, {
          x: 330,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length > 10 && name.length <= 15) {
        firstPage.drawText(name, {
          x: 310,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length > 15 && name.length <= 17) {
        firstPage.drawText(name, {
          x: 270,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length > 17 && name.length < 20) {
        firstPage.drawText(name, {
          x: 255,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length >= 20 && name.length <= 22) {
        firstPage.drawText(name, {
          x: 200,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length > 22 && name.length <= 25) {
        firstPage.drawText(name, {
          x: 180,
          y: 315,
          size: 44,
          font: SanChezFont,
          color: rgb(0.266, 0.266, 0.266),
        });
      } else if (name.length > 25) {
        let names = name.split(" ");
        if (names.length > 2) {
          let newname = names[0] + " " + names[1];

          console.log(newname);

          if (newname.length <= 5) {
            firstPage.drawText(newname, {
              x: 370,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (newname.length > 5 && newname.length <= 10) {
            firstPage.drawText(newname, {
              x: 330,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (newname.length > 10 && newname.length <= 15) {
            firstPage.drawText(newname, {
              x: 310,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (newname.length > 15 && newname.length <= 17) {
            firstPage.drawText(newname, {
              x: 270,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (newname.length > 17 && newname.length < 20) {
            firstPage.drawText(newname, {
              x: 255,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (newname.length >= 20 && newname.length <= 22) {
            firstPage.drawText(newname, {
              x: 200,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (newname.length > 22 && newname.length <= 25) {
            firstPage.drawText(newname, {
              x: 180,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          }
          if (newname.length > 25) {
            let firstname = names[0];
            if (firstname.length <= 5) {
              firstPage.drawText(firstname, {
                x: 370,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length > 5 && firstname.length <= 10) {
              firstPage.drawText(firstname, {
                x: 330,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length > 10 && firstname.length <= 15) {
              firstPage.drawText(firstname, {
                x: 310,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length > 15 && firstname.length <= 17) {
              firstPage.drawText(firstname, {
                x: 270,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length > 17 && firstname.length < 20) {
              firstPage.drawText(firstname, {
                x: 255,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length >= 20 && firstname.length <= 22) {
              firstPage.drawText(firstname, {
                x: 200,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length > 22 && firstname.length <= 25) {
              firstPage.drawText(firstname, {
                x: 180,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            } else if (firstname.length > 25) {
              firstPage.drawText(firstname, {
                x: 150,
                y: 315,
                size: 44,
                font: SanChezFont,
                color: rgb(0.266, 0.266, 0.266),
              });
            }
          }
        } else {
          let onlyname = names[0];
          if (onlyname.length <= 5) {
            firstPage.drawText(onlyname, {
              x: 370,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (onlyname.length > 5 && onlyname.length <= 10) {
            firstPage.drawText(onlyname, {
              x: 330,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (onlyname.length > 10 && onlyname.length <= 15) {
            firstPage.drawText(onlyname, {
              x: 310,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (onlyname.length > 15 && onlyname.length <= 17) {
            firstPage.drawText(onlyname, {
              x: 270,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (onlyname.length > 17 && onlyname.length < 20) {
            firstPage.drawText(onlyname, {
              x: 255,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (onlyname.length >= 20 && onlyname.length <= 22) {
            firstPage.drawText(onlyname, {
              x: 200,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else if (onlyname.length > 22 && onlyname.length <= 25) {
            firstPage.drawText(onlyname, {
              x: 180,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          } else {
            firstPage.drawText(onlyname, {
              x: 150,
              y: 315,
              size: 44,
              font: SanChezFont,
              color: rgb(0.266, 0.266, 0.266),
            });
          }
        }
      }

      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      // console.log("Done creating");

      // this was for creating uri and showing in iframe

      const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      // document.getElementById("pdf").src = pdfDataUri;
      let filename = name + ".pdf";

      var file = new File([pdfBytes], filename, {
        type: "application/pdf;charset=utf-8",
      });
      saveAs(file);
    },
    async generateLOR() {
      let name = this.FullName;

      var options = { year: "numeric", month: "long", day: "numeric" };
      var today = new Date();

      let currentdate = today.toLocaleDateString("en-US", options);
      const url = this.lor;
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer()
      );

      // Load a PDFDocument from the existing PDF bytes
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      // //get font
      let fonturl =
        "https://firebasestorage.googleapis.com/v0/b/flairboat-9a97e.appspot.com/o/Arimo-VariableFont_wght.ttf?alt=media&token=91227da0-5aad-433f-83f5-b99959248dc8";
      const fontBytes = await fetch(fonturl).then((res) => res.arrayBuffer());

      // // Embed our custom font in the document
      const SanChezFont = await pdfDoc.embedFont(fontBytes);
      // const SanChezFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

      // // Get the first page of the document
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      // // Draw a string of text diagonally across the first page
      firstPage.drawText(currentdate, {
        x: 89,
        y: 698,
        size: 13.5,
        font: SanChezFont,
        color: rgb(0, 0, 0),
      });
      if (name.length <= 10) {
        firstPage.drawText(name, {
          x: 265,
          y: 586,
          size: 14,
          font: SanChezFont,
          color: rgb(0, 0, 0),
        });
      }
      if (name.length > 10 && name.length <= 15) {
        firstPage.drawText(name, {
          x: 255,
          y: 586,
          size: 14,
          font: SanChezFont,
          color: rgb(0, 0, 0),
        });
      }
      if (name.length > 15 && name.length <= 25) {
        firstPage.drawText(name, {
          x: 220,
          y: 586,
          size: 13.5,
          font: SanChezFont,
          color: rgb(0, 0, 0),
        });
      } else if (name.length > 25) {
        let names = name.split(" ");
        if (names.length > 2) {
          let newname = names[0] + " " + names[1];
          if (newname.length > 25) newname = names[0];
          firstPage.drawText(newname, {
            x: 217,
            y: 586,
            size: 13.5,
            font: SanChezFont,
            color: rgb(0, 0, 0),
          });
        } else {
          firstPage.drawText(names[0], {
            x: 217,
            y: 586,
            size: 13.5,
            font: SanChezFont,
            color: rgb(0, 0, 0),
          });
        }
      }
      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      // console.log("Done creating");

      // this was for creating uri and showing in iframe

      const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      //  document.getElementById("pdf").src = pdfDataUri;
      let filename = "LOR" + ".pdf";

      var file = new File([pdfBytes], filename, {
        type: "application/pdf;charset=utf-8",
      });
      saveAs(file);
    },
    onCopy() {
      this.$vs.notify({
        title: "Success",
        text: "Referral ID is copied successfully",
        color: "success",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-check-circle",
      });
    },
    onError() {
      this.$vs.notify({
        title: "Failed",
        text: "Error in copying text",
        color: "danger",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-alert-circle",
      });
    },

    color(val) {
      if (val == "Active" || val == "On-Campus") {
        return "success";
      } else if (val == "Screening") {
        return "warning";
      } else if (val == "Closed") {
        return "danger";
      } else if (val == "Off-Campus") {
        return "primary";
      }
    },
  },
  computed: {
    path() {
      //    var paths = this.$router.resolve({name: 'recruiter-postedjob', query: {id: this.id}}).href
      //    this.fullUrl = window.location.origin + paths
      return this.RefCode;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    barprogress() {
      if (this.totalstudent > 2000) return true;
      else false;
    },
    mile1() {
      // console.log(this.milestone1 >= 100);
      return this.milestone1 >= 100 ? true : false;
    },
    mile2() {
      return this.milestone2 >= 100 ? true : false;
    },
    mile3() {
      return this.milestone3 >= 100 ? true : false;
    },
    mile4() {
      return this.milestone4 >= 100 ? true : false;
    },

    res() {
      /*let i= 0 
        var arr =[]
        for(i=0 ; i<= 4 ; i++){
          if(this.users[i]){
        arr.push(this.users[i])
          }
        } */
      return this.users;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  created() {
    // Goal Overview

    //  User Reward Card

    // Subscribers gained - Statistic

    const thisIns = this;
    const user = firebase.auth().currentUser;

    if (thisIns.$acl.get[0] === "editor") {
      // On Campus Jobs

      let db = firebase.firestore();

      var u = firebase.auth().currentUser;

      db.collection("StudentID")
        .doc(u.uid)
        .get()
        .then((doc) => {
          if (typeof doc.data().FullName != "undefined")
            this.FullName = doc.data().FullName;
          let profilephoto = "";
          if (typeof doc.data().profilephoto != "undefined")
            profilephoto = doc.data().profilephoto;
          this.logo = profilephoto;

          let Ref = db.collection("CampusAccounts").doc(u.uid);
          Ref.get().then(async (doc) => {
            if (doc.exists) {
              let arr = doc.data();
              if (typeof arr.RefCode === "undefined" || arr.RefCode === "") {
                await this.codegen();
                await db.collection("CampusAccounts").doc(u.uid).set(
                  {
                    RefCode: this.RCode,
                  },
                  { merge: true }
                );
                this.RefCode = this.RCode;
              } else this.RefCode = doc.data().RefCode;

              db.collection("StudentID")
                .where("referralCode", "==", this.RefCode)
                .orderBy("timestamp", "desc")
                .onSnapshot((snapshot) => {
                  this.totalstudent = snapshot.size;
                  let ts = 0;
                  snapshot.docChanges().forEach((change) => {
                    if (change.type === "added") {
                      // console.log(change.doc.data());
                      var applied = [];
                      applied = change.doc.data().AppliedIn;
                      if (typeof applied !== "undefined") {
                        if (applied.length >= 1) {
                          ts = ts + 1;
                          this.users.push(change.doc.data());
                        }
                      }
                    }
                  });
                  db.collection("Codes")
                    .doc("ReferralCodes")
                    .get()
                    .then((doc) => {
                      if (doc.exists) {
                        let apk = doc.data();
                        this.milestone1 = (ts / apk.milestone1) * 100;
                        this.milestone2 = (ts / apk.milestone2) * 100;
                        this.milestone3 = (ts / apk.milestone3) * 100;
                        this.milestone4 = (ts / apk.milestone4) * 100;
                        this.certificate = apk.certificate;
                        this.lor = apk.lor;
                      }
                    });
                });
            } else {
              db.collection("StudentID")
                .doc(u.uid)
                .get()
                .then(async (doc) => {
                  let arr2 = doc.data();
                  await this.codegen();
                  this.RefCode = this.RCode;
                  db.collection("CampusAccounts").doc(u.uid).set(
                    {
                      FullName: arr2.FullName,
                      RefCode: this.RCode,
                      profilephoto: profilephoto,
                      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    },
                    { merge: true }
                  );
                });
            }
          });
        });
    }
  },
};
</script>

<style lang="scss">
#CopyCode {
  input:disabled {
    background-color: #ffffff;
    border: 1px solid #ffffff;
    opacity: 1;
  }
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
